import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { AudienceUser } from './audience-user.model';

export class AudienceUserStateModel extends EntityStateModel<AudienceUser> {
    totalCount: number;
    pageNumber: number;
}
